import React, { ComponentProps } from 'react';
import { DefaultView, Views } from '../../types/BlockWithViews';
import { RoleSettingsDefaultForm } from './views/RoleSettingsDefaultForm';
import { asBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';

type RoleSettingsProps = Views<DefaultView<RoleSettingsDefaultForm>>;
function RoleSettings(props: RoleSettingsProps) {
  return <RoleSettingsDefaultForm {...props.views.default} />;
}

export const RoleSettingsBlock = asBlock(RoleSettings, BlockType.rolesettings);
export type RoleSettingsBlock = ComponentProps<typeof RoleSettingsBlock>;
